var map = {
	"./en-US": "aa9c",
	"./en-US.js": "aa9c",
	"./fr-FR": "70e9",
	"./fr-FR.js": "70e9",
	"./he-IL": "b539",
	"./he-IL.js": "b539",
	"./template": "ee5b",
	"./template.js": "ee5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f58";